import {
  createModalDataToken,
  createModalOpener
} from 'src/app/helpers/create-modal-opener';
import { ClientDto } from 'src/app/models/client/client-dto';
import { RulePropertyEditEvent } from '../../model/rule-property-edit-event';
import { NotificationsSetupClientIdsModalComponent } from './notifications-setup-client-ids-modal.component';

interface NotificationsSetupClientIdsModalInput {
  readonly notificationRuleId: string;
  readonly clients: ClientDto[];
}

export interface NotificationsSetupClientIdsModalOutput {
  readonly saveAction: RulePropertyEditEvent<ClientDto[]>;
  readonly cancelAction: void;
}

export const NOTIFICATIONS_SETUP_CLIENT_IDS_MODAL_DATA =
  createModalDataToken<NotificationsSetupClientIdsModalInput>(
    'NotificationsSetupClientIdsModalData'
  );

export const notificationsSetupClientIdsModalOpener = createModalOpener<
  NotificationsSetupClientIdsModalComponent,
  NotificationsSetupClientIdsModalInput,
  NotificationsSetupClientIdsModalOutput
>(
  NotificationsSetupClientIdsModalComponent,
  NOTIFICATIONS_SETUP_CLIENT_IDS_MODAL_DATA,
  { backdrop: 'static' }
);
